/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import NavLinkbar from "./components/NavLinkBar";

import * as St from "./styles";

function App() {
  const redirectToWhatsApp = async () => {
    setTimeout(function () {
      if (document.hasFocus()) {
        window.open(
          "https://api.whatsapp.com/send/?phone=559240033203&text=Ola_Quero_Negociar.&type=phone_number&app_absent=0",
          "_blank"
        );
      }
    }, 1000);
  };

  useEffect(() => {
    redirectToWhatsApp();
  }, []);

  return (
    <St.Container>
      <NavLinkbar />
    </St.Container>
  );
}

export default App;
